import { Reveal } from "@/components/site/motion";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS, CONTACT } from "@/data/content";

const Faq = () => (
  <section id="faq" className="bg-sand2 py-24 md:py-36 scroll-mt-24">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10 grid md:grid-cols-12 gap-12">
      <div className="md:col-span-4">
        <Reveal>
          <p className="text-sm uppercase tracking-[0.25em] text-terracotta mb-4">Questions</p>
          <h2 className="font-serif text-4xl md:text-5xl text-forest tracking-tight leading-[1.02]">
            Answers, before you even ask
          </h2>
          <p className="mt-6 text-ink2 leading-relaxed">
            Still unsure about something? Call us any time at{" "}
            <a href={CONTACT.phoneHref} className="text-forest font-semibold underline underline-offset-4">{CONTACT.phone}</a>.
            Our team is here 24/7, with no judgement.
          </p>
        </Reveal>
      </div>

      <div className="md:col-span-8">
        <Reveal>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="border-line">
                <AccordionTrigger data-testid={`faq-${i}`} className="text-left font-serif text-xl md:text-2xl text-forest hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-ink2 text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Faq;
